import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import Chart from 'chart.js/auto';
import { AuthService } from '../../services/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [DashboardComponent, ChartModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  myData: any;
  basicData: any;
  basicOptions: any;
  activeBusinessname: any;
  barChart: any = [];
  lineChart: any = [];
  constructor(private authService: AuthService, private notification: NzNotificationService){}
  ngOnInit() {
    this.getData();
    this.activeBusinessname = localStorage.getItem('activeBusinessName');
    this.barChart = new Chart('barChart', {
      type: 'bar',
      data: {
        labels: [
          'Bonus',
          'Referral',
          'Balance',
          'Check-In',
          'Transactions',
          'Tasks',
        ],
        datasets: [
          {
            label: 'Total Number #',
            data: [12, 19, 3, 5, 2, 3],
            borderWidth: 1,
            borderColor: '#081A46',
            backgroundColor: '#081A46',
            borderRadius: 5,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
    this.lineChart = new Chart('lineChart1', {
      type: 'line',
      data: {
        labels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        datasets: [
          {
            label: 'Total Number #',
            data: [10, 20, 10, 50, 45, 25, 70],
            borderColor: '#081A46',
            // backgroundColor: '#081A46',
            backgroundColor: '#081A46',
            borderWidth: 1,
            tension: 0.1,
            fill: false,
            pointStyle: false,
            showLine: true
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
    this.lineChart = new Chart('lineChart2', {
      type: 'line',
      data: {
        labels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        datasets: [
          {
            label: 'Total Number #',
            data: [10, 20, 10, 50, 45, 25, 70],
            borderColor: '#081A46',
            // backgroundColor: '#081A46',
            backgroundColor: '#081A46',
            borderWidth: 1,
            tension: 0.1,
            fill: false,
            pointStyle: false,
            showLine: true
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
    this.lineChart = new Chart('lineChart3', {
      type: 'line',
      data: {
        labels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        datasets: [
          {
            label: 'Total Number #',
            data: [10, 20, 10, 50, 45, 25, 70],
            borderColor: '#081A46',
            // backgroundColor: '#081A46',
            backgroundColor: '#081A46',
            borderWidth: 1,
            tension: 0.1,
            fill: false,
            pointStyle: false,
            showLine: true
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
    this.lineChart = new Chart('lineChart4', {
      type: 'line',
      data: {
        labels: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        datasets: [
          {
            label: 'Total Number #',
            data: [10, 20, 10, 50, 45, 25, 70],
            borderColor: '#081A46',
            // backgroundColor: '#081A46',
            backgroundColor: '#081A46',
            borderWidth: 1,
            tension: 0.1,
            fill: false,
            pointStyle: false,
            showLine: true
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }
  getData(){
    this.authService.me().subscribe({
      next: (res: any) => {
        this.myData = res;
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to get user data', {
          nzClass: 'notification',
        });
      },
    });
  }
  
}
